import { render, staticRenderFns } from "./ModalContentCourseDetails.vue?vue&type=template&id=c8c6c586&"
import script from "./ModalContentCourseDetails.vue?vue&type=script&lang=js&"
export * from "./ModalContentCourseDetails.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentCourseDetails.vue?vue&type=style&index=0&id=c8c6c586&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports